import EditProfile from "./display_general_info/EditProfile";
import EmailPasswordUpdateForm from "./EmailPasswordUpdateForm";
import ScheduleSettings from "./ScheduleSettings";
import NotificationsSettings from "./NotificationsSettings";
import PropTypes from "prop-types";

const RightSide = ({ page }) => {
  const pagesArray = [
    { component: <EditProfile />, value: "general_info" },
    { component: <EmailPasswordUpdateForm />, value: "email" },
    { component: <ScheduleSettings />, value: "schedule" },
    { component: <NotificationsSettings />, value: "notifications" },
  ];

  return (
    <div className="profile__show-right-side">
      {pagesArray.find((p) => p.value === page)?.component || <EditProfile />}
    </div>
  );
};

RightSide.propTypes = {
  page: PropTypes.string,
};

export default RightSide;
